<template>
  <div class="content">
    <div class="background-index">
      <div
        class="top-title common"
      >
        同声传译服务专窗
      </div>
      <div
        class="middle-title common"
      >
      Simultaneous Interpreting Services
      </div>
      <div
        class="common mark-box"
      >
        <div
          class="mark"
          :key="item.name"
          v-for="item in data"
        >
          <p>{{item.name}}</p>
          <p>{{item.english}}</p>
        </div>
      </div>
      <div class="bottom-operator common">
        <div @click="pushRouter('/htmlContent?type=contentNews&contentCode=RESF27EF67D23ECEAC&name=口译服务&linkname=翻译服务/口译服务/详情')">
          <img src="../../../assets/images/icon_hump_interpreting_services.png">
          <div>
            <p>口译服务</p>
            <p>Interpreting Services</p>
          </div>
        </div>
        <div @click="pushRouter('/htmlContent?type=contentNews&contentCode=RESDF11AAACE6BCD79&name=同传设备&linkname=国际会议/同传设备/详情')">
          <img src="../../../assets/images/icon_jump_interpreting_equi_hire.png">
          <div>
            <p>同传设备</p>
            <p>Equipment Rental</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const data = [
  {name: '高端', english: 'Exceptional'},
  {name: '品质', english: 'Reliable'},
  {name: '专业', english: 'Professional'},
  {name: '热情', english: 'Dedicated'},
]
export default {
  name: 'some-inter',
  data() {
    return {
      data
    }
  },
  created() {
    window.scrollTo(0,0)
  }
}
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  height: 637px;
}
.background-index {
  height: 637px;
  width: 100%;
  position: absolute;
  index: -1;
  background-image: url('../../../assets/images/bg_jump_interpret.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position:center;
}
.top-title {
  width: 574px;
  height: 65px;
  font-size: 68px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 30px;
  top: 139px;
}
.middle-title {
  width: 736px;
  height: 31px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 30px;
  top: 221px;
}
.bottom-operator {
  width: 834px;
  height: 100px;
  display: flex;
  top: 442px;
  > div:last-of-type {
    margin-left: 17px;
  }
  > div:first-of-type {
    margin-right: 17px;
  }
  > div {
    cursor: pointer;
    background: #fff;
    width: 400px;
    height: 100px;
    text-align: left;
    img {
      width: 64px;
      height: 64px;
      margin: 0 32px 0 61px;
    }
    > div {
      display: inline-block;
      transform: translateY(40%);
      > p {
        margin: 0;
        padding: 0;
      }
      > p:first-of-type {
        height: 26px;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3A3A3A;
        text-align: center;
      }
      > p:last-of-type {
        height: 13px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3A3A3A;
        margin-top: 9px;
      }
    }
  }
}
.common {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.mark-box {
  top: 349px;
}
.mark {
  position: relative;
  display: inline-block;
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.6);
  > p:first-of-type {
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-bottom: 0px;
  }
  > p:last-of-type {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 0px;
  }
}
.mark:not(:last-of-type)::after {
  content: '';
  display: inline-block;
  width: 12px;
  height: 12px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  position: absolute;
  right: -17px;
  top: 42%;
}
</style>



// WEBPACK FOOTER //
// src/components/content/someInter/index.vue